import { render } from "./RowspanAndColspan.vue?vue&type=template&id=5058bce0"
import script from "./RowspanAndColspan.vue?vue&type=script&lang=js"
export * from "./RowspanAndColspan.vue?vue&type=script&lang=js"
script.render = render

export default script